
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/om-os",
      function () {
        return require("private-next-pages/om-os/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/om-os"])
      });
    }
  